import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import AddIcon from '@mui/icons-material/Add';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import PageLayout from '../../components/layout/PageLayout';
import DataTable from '../../components/ui/DataTable';
import ActionIconButton from '../../components/ui/ActionIconButton';
import { notify } from '../../components/feedback/notify';
import { MascaraCpf } from "../../utils/MascaraCpf";
import { MascaraTelefone } from "../../utils/MascaraTelefone";
import { MascaraCnpj } from "../../utils/MascaraCnpj";

function Usuarios() {

    const token = localStorage.getItem('token');
    const navigate = useNavigate();
    const [usuarios, setUsuarios] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const getUsuarios = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_URL}/listarUsuarios`, {
                    headers: {
                        Authorization: token
                    }
                });

                if (response.data.status === 200) {
                    setUsuarios(response.data.usuarios || []);
                }
            } catch (error) {
                console.error("Erro ao listar usuários:", error);
                notify.error("Não foi possível carregar a lista de usuários.");
            } finally {
                setLoading(false);
            }
        }

        getUsuarios();
    }, [token])

    const columns = [
        { key: 'idUsuario', label: 'ID', width: 72 },
        { key: 'Nome', label: 'Nome', sx: { fontWeight: 500 }, render: (u) => u?.Nome || '—' },
        { key: 'Email', label: 'E-mail', render: (u) => u?.Email || '—' },
        { key: 'Cpf', label: 'CPF', render: (u) => MascaraCpf(u?.Cpf) || '—' },
        { key: 'Cnpj', label: 'CNPJ', render: (u) => MascaraCnpj(u?.Cnpj) || '—' },
        { key: 'RazaoSocial', label: 'Razão Social', render: (u) => u?.RazaoSocial || '—' },
        { key: 'Telefone', label: 'Telefone', render: (u) => MascaraTelefone(u?.Telefone) || '—' },
        { key: 'acoes', label: 'Ações', align: 'right', width: 80, render: () => <ActionIconButton title="Editar" icon={<EditOutlinedIcon fontSize="small" />} pending /> },
    ];

    return (
        <PageLayout
            title="Usuários"
            subtitle="Clientes cadastrados na plataforma."
            breadcrumbs={[{ label: 'Dashboard', to: '/dashboard' }, { label: 'Usuários' }]}
            actions={
                <>
                    <Button variant="outlined" startIcon={<AdminPanelSettingsOutlinedIcon />} onClick={() => navigate("../Admins")}>
                        Administradores
                    </Button>
                    <Tooltip title="Em desenvolvimento">
                        <span>
                            <Button variant="contained" startIcon={<AddIcon />} disabled>
                                Adicionar usuário
                            </Button>
                        </span>
                    </Tooltip>
                </>
            }
        >
            <DataTable
                columns={columns}
                rows={usuarios}
                getRowKey={(u, i) => u?.idUsuario ?? i}
                loading={loading}
                emptyMessage="Nenhum usuário cadastrado."
            />
        </PageLayout>
    );
}

export default Usuarios;
